import axios from "axios";
import config, { Config, Country } from "./config";

async function initConfig() {
    const response = await axios.get<Config>("/config.json");
    config.set(response.data);
}

export { config, initConfig };
export type { Config, Country };
